import React from "react";
import ReactDOM from "react-dom";

import ArticleSection from "./ArticleSection";

const articleSections = document.getElementsByClassName("ArticleSection");

if (articleSections) {
    for (let i = 0; i < articleSections.length; i++) {
        let dataset = articleSections[i].dataset;

        ReactDOM.render(
            <ArticleSection
                autoAttached={dataset.autoattached === "true" ? true : false}
                article={dataset.article ? dataset.article : null}
                preview={typeof dataset.preview !== "undefined" ? true : false}
                order={dataset.order ? dataset.order : null}
            />,
            articleSections[i]
        );
    }
}